import { State } from './state'
import { MutationTypes } from './type'

import {
  RequestItemModel
} from '@/groupBuy/types'

const updateRequestListItem = (requestList: RequestItemModel[], requestUuid: string, updatedValues: { [key: string]: any }) => {
  const index = requestList.findIndex(item => item.uuid === requestUuid)
  if (index > -1) {
    const request = { ...requestList[index] }
    Object.assign(request, updatedValues)
    requestList.splice(index, 1, request)
  }
}
export type Mutations<S = State> = {
  [MutationTypes.SET_REQUEST_LIST](state: S, payload: RequestItemModel[]): void,
  [MutationTypes.REMOVE_REQUEST](state: S, payload: string): void,
  [MutationTypes.SET_NOTIFICATION](state: S, payload: { [key: string]: string }): void,
  [MutationTypes.UPDATE_REQUEST_INPUT_SIZE_LIST](state: S, payload: {
    requestUuid: string,
    data: { [key: string]: any }
  }): void,
  [MutationTypes.UPDATE_REQUEST_ACCEPTING_INPUT](state: S, payload: {
    requestUuid: string,
    acceptingInput: boolean,
    isLock: boolean
  }): void,
}

export const mutations: Mutations = {
  [MutationTypes.SET_REQUEST_LIST]: (state, payload) => {
    state.requestList = payload
  },
  [MutationTypes.REMOVE_REQUEST]: (state, uuid) => {
    const index = state.requestList.findIndex(item => item.uuid === uuid)
    if (index > -1) {
      const updatedList = state.requestList.slice()
      updatedList.splice(index, 1)
      state.requestList = updatedList
    }
  },
  [MutationTypes.SET_NOTIFICATION]: (state, payload) => {
    state.notifications = payload
  },
  [MutationTypes.UPDATE_REQUEST_INPUT_SIZE_LIST]: (state, payload) => {
    updateRequestListItem(state.requestList, payload.requestUuid, {
      ...payload.data
    })
  },
  [MutationTypes.UPDATE_REQUEST_ACCEPTING_INPUT]: (state, payload) => {
    updateRequestListItem(state.requestList, payload.requestUuid, {
      acceptingInput: payload.acceptingInput,
      isLock: payload.isLock
    })
  }
}
